import { render } from "./TheHeader.vue?vue&type=template&id=7de848ca&scoped=true"
const script = {}

import "./TheHeader.vue?vue&type=style&index=0&id=7de848ca&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7de848ca"

export default script